<template>
  <BCol
    :xxl="slideMode ? '12' : '2'"
    :xl="slideMode ? '12' : '4'"
    :lg="slideMode ? '12' : '4'"
    :md="'12'"
    :sm="'12'"
    class="glpi-col"
  >
    <BCard no-body class="status-card border-0 w-100 overflow-hidden" :style="cardVars">
      <BCardBody class="status-card-body">
        <div class="status-card-header">
          <div class="status-copy pe-3">
            <p class="status-title mb-1">{{ title }}</p>
            <h4 class="status-value mb-1">
              <count-to :startVal="0" :endVal="Number(data) || 0" :duration="1000" />
            </h4>
            <p class="status-subtitle mb-0">{{ subtitle }}</p>
          </div>
          <span class="status-icon-wrap">
            <i :class="iconClass"></i>
          </span>
        </div>
        <span class="status-line"></span>
      </BCardBody>
    </BCard>
  </BCol>
</template>

<style scoped>
.glpi-col {
  display: flex;
}

.status-card {
  position: relative;
  background:rgba(255, 255, 255, 0.98);
  border: 2px solid #cecece;
  border-radius: 1.15rem;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
}

.status-card-body {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 1rem 1.05rem;
}

.status-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.status-copy {
  flex: 1 1 auto;
  min-width: 0;
}

.status-title {
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.status-value {
  font-size: 2rem;
  font-weight: 800;
  line-height: 1;
  color: #0f172a;
}

.status-subtitle {
  font-size: 0.84rem;
  line-height: 1.45;
  color: #64748b;
}

.status-icon-wrap {
  width: 2.85rem;
  height: 2.85rem;
  border-radius: 0.95rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--status-accent-soft);
  color: var(--status-accent);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.45);
}

.status-icon-wrap i {
  font-size: 1.15rem;
}

.status-line {
  display: block;
  width: 100%;
  height: 0.28rem;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--status-accent) 0%);
  opacity: 0.68;
}

[data-bs-theme="dark"] .status-card {
  background:
    linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(21, 31, 53, 0.9) 100%);
  border-color: rgba(148, 163, 184, 0.16);
  box-shadow: 0 14px 30px rgba(2, 8, 20, 0.28);
}

[data-bs-theme="dark"] .status-title {
  color: #8ea0bc;
}

[data-bs-theme="dark"] .status-value {
  color: #e5eefb;
}

[data-bs-theme="dark"] .status-subtitle {
  color: #9fb0c9;
}

[data-bs-theme="dark"] .status-icon-wrap {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.03);
}

@media (max-width: 768px) {
  .status-card-body {
    padding: 0.95rem;
  }

  .status-value {
    font-size: 1.8rem;
  }
}
</style>

<script>
import { CountTo } from "vue3-count-to";

export default {
  name: "cardTotalchamados",
  components: { CountTo },
  props: {
    status: {
      type: Number,
      required: true,
    },
    data: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    slideMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: "",
      subtitle: "",
      iconClass: "ri-file-list-3-line",
      iconColor: "#3b82f6",
      iconBg: "#e6f0ff",
    };
  },
  computed: {
    cardVars() {
      return {
        "--status-accent": this.iconColor,
        "--status-accent-soft": this.iconBg,
      };
    },
  },
  methods: {
    applyStatusConfig() {
      if (this.status === 1) {
        this.title = "NOVOS";
        this.subtitle = "Chamados recém-abertos";
        this.iconClass = "ri-inbox-archive-line";
        this.iconColor = "#16a34a";
        this.iconBg = "#dcfce7";
      } else if (this.status === 2) {
        this.title = "PENDENTES";
        this.subtitle = "Aguardando interação";
        this.iconClass = "ri-time-line";
        this.iconColor = "#d97706";
        this.iconBg = "#ffedd5";
      } else if (this.status === 3) {
        this.title = "EM EXECUÇÃO";
        this.subtitle = "Em atendimento técnico";
        this.iconClass = "ri-tools-line";
        this.iconColor = "#0284c7";
        this.iconBg = "#dbeafe";
      } else if (this.status === 4) {
        this.title = "SOLUCIONADOS";
        this.subtitle = "Aguardando sua validação";
        this.iconClass = "ri-checkbox-circle-line";
        this.iconColor = "#7c3aed";
        this.iconBg = "#ede9fe";
      } else if (this.status === 5) {
        this.title = "FINALIZADOS";
        this.subtitle = "Concluídos com sucesso";
        this.iconClass = "ri-check-double-line";
        this.iconColor = "#2563eb";
        this.iconBg = "#dbeafe";
      } else if (this.status === 6) {
        this.title = "AVALIADOS";
        this.subtitle = "Chamados avaliados";
        this.iconClass = "ri-star-smile-line";
        this.iconColor = "#db2777";
        this.iconBg = "#fce7f3";
      }
    },
  },
  watch: {
    status: {
      immediate: true,
      handler() {
        this.applyStatusConfig();
      },
    }
  },
};
</script>
